import { render, staticRenderFns } from "./AddExpenses.vue?vue&type=template&id=339eed22&scoped=true"
import script from "./AddExpenses.vue?vue&type=script&lang=js"
export * from "./AddExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339eed22",
  null
  
)

export default component.exports